import {
  POST_FIELDS,
  OPERATION,
} from '@/services/charts-service';
import { DATA_TYPE } from '@/store/modules/cards/constants';

/*
  Property of change logs objects:

  control: in Timestamp (to generate the time use (new Date()).getTime())
  match: Array,
    property: Any,
  change: Object,
    property: Any,
*/

export default [
  {
    control: 1630085066000,
    match: [
      {
        component: 'TopInfluencers',
      },
      {
        component: 'TopPosts',
      },
      {
        component: 'TopLikedPosts',
      },
      {
        component: 'NewPosts',
      },
      {
        component: 'TopPostsByFollowers',
      },
      {
        component: 'TopPostsByInteractions',
      },
      {
        component: 'PropBaseShareSentiment',
        props: {
          operation: OPERATION.COUNT,
          group: POST_FIELDS.OPERATOR,
        },
      },
    ],
    change: {
      shareable: false,
    },
  },
  {
    control: 1660824687000,
    match: [
      {
        component: 'EngagementMatrix',
      },
    ],
    change: {
      props: {
        description: 'Compara engajamento, impressões e índice de sentimento dos comentários das publicações proprietárias do período. A divisão dos quadrantes é data pela média aritimética dos últimos 90 dias.',
      },
    },
  },
  {
    control: 1660824688000,
    match: [
      {
        component: 'EngagementMatrix',
        props: {
          type: 'tags',
        },
      },
    ],
    change: {
      props: {
        description: 'Compara engajamento, impressões e índice de sentimento dos comentários das publicações do período, por tag. A divisão dos quadrantes é data pela média aritimética dos últimos 90 dias.',
      },
    },
  },
  {
    control: 1661879019000,
    match: [
      {
        component: 'SacReportCallsQuantity',
      },
      {
        component: 'PropBaseShareSentiment',
        shareable: false,
      },
    ],
    change: {
      dataType: DATA_TYPE.SAC_STATUS,
    },
  },
  {
    control: 1662392706000,
    match: [
      {
        component: 'SessionDivider',
      },
    ],
    change: {
      hideMenu: true,
      props: {
        annotation: '',
      },
    },
  },
  {
    control: 1666374586000,
    match: [
      {
        component: 'PropBaseShareSentiment',
        props: {
          tags: 'Sentimento; Canais',
        },
      },
    ],
    change: {
      control: {
        tiktok: {
          hideInChannel: true,
          disableTag: false,
          disableTheme: false,
          disablePolarity: false,
        },
      },
    },
  },
  {
    control: 1666655334000,
    match: [
      {
        component: 'AnnotationTextCard',
      },
    ],
    change: {
      width: 4,
      props: {
        title: '',
        noPadding: true,
      },
    },
  },
  {
    control: 1669299432000,
    match: [
      {
        component: 'AnnotationImageCard',
      },
    ],
    change: {
      props: {
        description: 'Componente para inserir imagens por arquivo ou via URLs.',
      },
    },
  },
  {
    control: 1673267129000,
    match: [
      {
        component: 'PropBaseShareSentiment',
        props: {
          tags: 'Sentimento; Categorias e Anotações',
        },
      },
    ],
    change: {
      control: {
        tiktok: {
          hideInChannel: true,
          disableTag: false,
          disableTheme: false,
          disablePolarity: false,
        },
      },
    },
  },
  {
    control: 1673268119000,
    match: [
      {
        component: 'PropSentimentTimeSeries',
        props: {
          tags: 'Sentimento; Engajamento',
        },
      },
    ],
    change: {
      control: {
        tiktok: {
          hideInChannel: true,
          disableTag: false,
          disableTheme: false,
          disablePolarity: false,
        },
      },
    },
  },
  {
    control: 1673272320000,
    match: [
      {
        component: 'PropSentimentGauge',
        props: {
          tags: 'Sentimento; Engajamento',
        },
      },
    ],
    change: {
      control: {
        tiktok: {
          hideInChannel: true,
          disableTag: false,
          disableTheme: false,
          disablePolarity: false,
        },
      },
    },
  },
  {
    control: 1673272604000,
    match: [
      {
        component: 'PropBaseShareSentiment',
        props: {
          tags: 'Sentimento; Demográficos',
        },
      },
    ],
    change: {
      control: {
        tiktok: {
          hideInChannel: true,
          disableTag: false,
          disableTheme: false,
          disablePolarity: false,
        },
      },
    },
  },
  {
    control: 1673272743000,
    match: [
      {
        component: 'PropBaseShareSentiment',
        props: {
          tags: 'Sentimento; Categorias e Anotações',
        },
      },
    ],
    change: {
      control: {
        tiktok: {
          hideInChannel: true,
          disableTag: false,
          disableTheme: false,
          disablePolarity: false,
        },
      },
    },
  },
  {
    control: 1673273013000,
    match: [
      {
        component: 'PropSentimentPie',
        props: {
          tags: 'Sentimento; Engajamento',
        },
      },
    ],
    change: {
      control: {
        tiktok: {
          hideInChannel: true,
          disableTag: false,
          disableTheme: false,
          disablePolarity: false,
        },
      },
    },
  },
  {
    control: 1673273264000,
    match: [
      {
        component: 'PropSentimentTimeSeries',
        props: {
          tags: 'Sentimento ; Engajamento',
        },
      },
    ],
    change: {
      control: {
        tiktok: {
          hideInChannel: true,
          disableTag: false,
          disableTheme: false,
          disablePolarity: false,
        },
      },
    },
  },
  {
    control: 1673273530000,
    match: [
      {
        component: 'PropBaseShareSentiment',
        props: {
          tags: 'Menções e Publicações; Categorias e Anotações',
        },
      },
    ],
    change: {
      control: {
        tiktok: {
          hideInChannel: true,
          disableTag: false,
          disableTheme: false,
          disablePolarity: false,
        },
      },
    },
  },
  {
    control: 1673273683000,
    match: [
      {
        component: 'PropBaseShareSentiment',
        props: {
          tags: 'Menções e Publicações; Categorias e Anotações',
        },
      },
    ],
    change: {
      control: {
        tiktok: {
          hideInChannel: true,
          disableTag: false,
          disableTheme: false,
          disablePolarity: false,
        },
      },
    },
  },
  {
    control: 1673273962000,
    match: [
      {
        component: 'EngagementMatrix',
        props: {
          tags: 'Engajamento',
          type: 'tags',
        },
      },
    ],
    change: {
      control: {
        tiktok: {
          hideInChannel: true,
          disableTag: false,
          disableTheme: false,
          disablePolarity: false,
        },
      },
    },
  },
  {
    control: 1677505930416,
    match: [
      {
        component: 'BacklogTable',
      },
      {
        component: 'ChangeStatus',
      },
      {
        component: 'SLAGaugeChart',
      },
      {
        component: 'AnnotationsLogs',
      },
      {
        component: 'ReportOperatorsLogs',
      },
      {
        component: 'StockVsSentimentLineChart',
      },
      {
        component: 'StockVsSocialLineChart',
        props: {
          title: 'Comparativo preço x menções',
        },
      },
      {
        component: 'StockVsSocialLineChart',
        props: {
          title: 'Comparativo volume x menções',
        },
      },
      {
        component: 'TextFilter',
      },
      {
        component: 'LogsTable',
      },
    ],
    change: {
      shareable: false,
    },
  },
  {
    control: 1679342640000,
    match: [
      {
        component: 'FanBaseEvolutionChart',
      },
    ],
    change: {
      control: {
        tiktok: {
          hideInChannel: true,
          disableTag: false,
          disableTheme: false,
          disablePolarity: false,
        },
      },
    },
  },
  {
    control: 1679342640001,
    match: [
      {
        component: 'FansTotal',
      },
    ],
    change: {
      control: {
        tiktok: {
          hideInChannel: true,
          disableTag: false,
          disableTheme: false,
          disablePolarity: false,
        },
      },
    },
  },
  {
    control: 1679342640002,
    match: [
      {
        component: 'NewFans',
      },
    ],
    change: {
      control: {
        tiktok: {
          hideInChannel: true,
          disableTag: false,
          disableTheme: false,
          disablePolarity: false,
        },
      },
    },
  },
];
